import React, { useEffect, useRef, useState } from 'react';
import medicalCare from '../../../assets/images/medicalcare.svg';
import addImage from '../../../assets/images/add-image.png';
import '../styles/CreateArticle.css';
import { getDownloadURL, ref, uploadBytesResumable, deleteObject } from 'firebase/storage';
import { storage } from '../../../helpers/Firebase';
import { POST } from '../../../helpers/httphelper';
import { toast as superToast } from 'bulma-toast';

function CreateArticle() {

  const [article, setArticle] = useState({
    heading: '',
    body: '',
    image: ''
  });
  const [btnState, setBtnState] = useState({
    heading: false,
    body: false,
    image: false
  });
  const [progress, setProgress] = useState(0);

  const handleInput = (e) => {
    e.preventDefault();
    setArticle(prev => ({ ...prev, [e.target.name]: e.target.value.trim() }));
    handleInputError(e.target.name, e.target.value.trim());
  }

  const imageRef = useRef();
  const headingRef = useRef();
  const bodyRef = useRef();
  const btnRef = useRef();

  const handleInputError = (name, value) => {
    if (value === '') {
      if (name === 'heading') {
        setBtnState(prev => ({ ...prev, heading: false }));
        headingRef.current.children[2].innerText = "*Required Heading Can't be empty";
      } else {
        setBtnState(prev => ({ ...prev, body: false }));
        bodyRef.current.children[2].innerText = "*Required Body Can't be empty";
      }
    } else {
      if (name === 'heading') {
        setBtnState(prev => ({ ...prev, heading: true }));
        headingRef.current.children[2].innerText = " ";
      } else {
        bodyRef.current.children[2].innerText = " ";
        setBtnState(prev => ({ ...prev, body: true }));
      }
    }
  }

  const handleImage = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    imageRef.current.children[0].children[1].innerText = file.name;
    imageRef.current.children[2].innerText = " ";
    if (!file) {
      return;
    } else {
      if (article.image !== '') {
        const delRef = ref(storage, article.image);

        deleteObject(delRef).then(() => {
          console.log('Photo Deleted from Storage');
          setProgress(0);
          setArticle(prev => ({ ...prev, image: '' }));
          setBtnState(prev => ({ ...prev, image: false }));
        }).catch((err) => {
          console.log(err);
        });
      }

      const storageRef = ref(storage, `/Articles/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on("state_changed", (snapshot) => {
        const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        setProgress(prog);
      }, (err) => {
        console.log(err);
      }, () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          console.log(url)
          setArticle(prev => ({ ...prev, image: url }));
          setBtnState(prev => ({ ...prev, image: true }));
        })
      })
    }
  }

  const handleCreate = async () => {
    const ob = {
      topic: article.heading,
      body: article.body,
      photo: article.image,
      userId: localStorage.getItem('user')
    }
    console.log(ob)
    try {
      const res = await POST('api/articles/create', ob);
      console.log(res);
      superToast({
        message: res.message,
        type: 'is-success',
        dismissible: true,
        position: "top-center",
        animate: { in: 'fadeIn', out: 'fadeOut' },
      })
      window.location.href = "http://localhost:3000/articles";
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (localStorage.getItem('user')) {
      if (btnState.body && btnState.image && btnState.heading) {
        btnRef.current.style.display = 'block';
      } else {
        btnRef.current.style.display = 'none';
      }
    }
  }, [btnState]);

  return (
    <div className='container'>
      <p className='title is-size-3-mobile is-1 has-text-centered mt-5'>Create Article</p>
      <div className="columns">
        <div className="column is-6">
          <div className='box'>
            <div className="field" ref={imageRef}>
              <label htmlFor='image' className='is-flex'>
                <figure className="image is-32x32">
                  <img className='img' src={addImage} alt='' />
                </figure>
                <span className='title is-size-4'>Insert Image</span>
              </label>
              <progress className="progress mt-3" style={{ borderRadius: '4px', marginBottom: 0 }} value={progress} max="100" />
              <small className='has-text-danger is-size-7'>*Required</small>
              <input type='file' name='image' id="image" style={{ display: "none" }} onChange={(e) => { handleImage(e) }} />
            </div>
            <div className="field" ref={headingRef}>
              <label htmlFor='heading' className='label mt-3'>Heading</label>
              <input type='text' name='heading' id="heading" className='input' placeholder='Heading' style={{ borderColor: '#7BC8FF', borderWidth: '2px' }} onChange={(e) => handleInput(e)} />
              <small className='has-text-danger is-size-7'>*Required</small>
            </div>
            <div className="field" ref={bodyRef}>
              <label htmlFor='body' className='label mt-3'>Body</label>
              <textarea rows='10' name='body' id='body' className="textarea has-fixed-size" placeholder='Content' style={{ borderColor: '#7BC8FF', borderWidth: '2px' }} onChange={(e) => handleInput(e)} />
              <small className='has-text-danger is-size-7'>*Required</small>
            </div>
            <div className="columns is-flex is-justify-content-center mt-2 mb-4">
              <button className="button btn" ref={btnRef} onClick={() => { handleCreate() }}>
                <span className="icon">
                  <i className="fas fa-plus-circle"></i>
                </span>
                <span>Create</span>
              </button>
            </div>
          </div>
        </div>
        <div className="column is-6 is-flex is-align-items-center">
          <figure className="image">
            <img src={medicalCare} alt='' />
          </figure>
        </div>
      </div>
    </div>
  )
}

export default CreateArticle;